import styled from 'styled-components';
import { languageStore } from '../../state/language';
import { LANGUAGES } from '../../i18n/languages';
// 언어 선택: 선택하면 i18n/DomTranslator가 사이트 전체 문구를 바꾼다.
const LanguageSelection = ({ inverted }) => {
    const lang = languageStore();
    return (<Div role="group" aria-label="Language" data-no-translate inverted={inverted}>
        <svg className="globe" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
            <circle cx="8" cy="8" r="6.2" />
            <ellipse cx="8" cy="8" rx="2.9" ry="6.2" />
            <path d="M1.8 8h12.4" />
            <path d="M2.8 4.5h10.4" />
            <path d="M2.8 11.5h10.4" />
        </svg>
        {LANGUAGES.map(({ code, label }) => (
            <button
                key={code}
                type="button"
                aria-pressed={lang.language === code}
                onClick={() => { localStorage.setItem("language", code); lang.setLanguage(code); }}
            >
                {label}
            </button>
        ))}
    </Div>)
}
export default LanguageSelection;
const Div = styled.div`
display: inline-flex;
align-items: center;
gap: 0.15rem;
flex-shrink: 0;
padding: 0.25rem;
border-radius: 999px;
border: 1px solid ${({ inverted, theme }) => (inverted ? "rgba(255, 255, 255, 0.2)" : theme.colors.line)};
background: ${({ inverted }) => (inverted ? "rgba(255, 255, 255, 0.12)" : "#EEF1F6")};
& > .globe {
    width: 1rem;
    height: 1rem;
    margin-left: 0.55rem;
    margin-right: 0.2rem;
    flex-shrink: 0;
    fill: none;
    stroke: ${({ inverted, theme }) => (inverted ? "rgba(255, 255, 255, 0.8)" : theme.colors.foreground.dimmed)};
    stroke-width: 1.2;
}
& > button {
    cursor: pointer;
    border: 0;
    border-radius: 999px;
    padding: 0.34rem 0.95rem;
    font-size: 0.8rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    background: transparent;
    color: ${({ inverted, theme }) => (inverted ? "rgba(255, 255, 255, 0.85)" : theme.colors.foreground.normal)};
    transition: background-color 0.2s, color 0.2s;
    &[aria-pressed="true"] {
        background: ${({ inverted, theme }) => (inverted ? "white" : theme.colors.dark)};
        color: ${({ inverted, theme }) => (inverted ? theme.colors.dark : "white")};
    }
}
/* 모바일은 헤더 공간이 좁아 콤팩트하게 유지 */
@media (max-width: 575px) {
    gap: 0;
    padding: 0.2rem;
    & > .globe {
        margin-left: 0.45rem;
        margin-right: 0.1rem;
    }
    & > button {
        padding: 0.32rem 0.72rem;
        letter-spacing: 0.02em;
    }
}
@media (max-width: 374px) {
    & > .globe {
        display: none;
    }
    & > button {
        padding: 0.28rem 0.5rem;
        font-size: 0.75rem;
    }
}
`;
